<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset, errors}" ref="observer" slim>
    <b-tab :title-link-class="hasErrors(errors) ? 'has-error' : ''">
      <template v-slot:title>
        {{ $t('Clerks / Languages') }}
        <span v-if="hasErrors(errors)" style="width: 20px;height: 20px" id="clerks-exclamation-icon">
          <font-awesome-icon class="text-danger hover-cursor" icon="exclamation-circle"/>
        </span>
        <b-tooltip v-if="hasErrors(errors)" target="clerks-exclamation-icon"
                   :title="$t('You have validation errors')"/>
      </template>
      <div class="row">
        <div class="col-md-12 col-lg-7">
          <div class="card">
            <div class="card-header d-flex align-items-center">
              <h5 class="mb-0">{{ $t('Clerks') }}</h5>
              <b-button class="ml-auto" variant="link" @click="onAddClerkClick()">
                <font-awesome-icon :icon="'plus'" style="font-size: .9em"></font-awesome-icon>
                {{ $t('New Clerk') }}
              </b-button>
            </div>
            <div class="card-body pt-0 pb-0">
              <artisio-table
                  :items="selectedBranch.clerks ? selectedBranch.clerks : []"
                  :fields="tableFields">
                <template slot="cell(name)" slot-scope="{item: clerk}">
                  {{ clerk.name }}
                  <action-buttons :view="false"
                                  @editClick="onEditClick(clerk)"
                                  @deleteClick="onRemoveClick(clerk)"/>
                </template>
                <template slot="cell(language)" slot-scope="{item: clerk}">
                  <span> {{ clerk.languages ? clerk.languages.map(l => l.name).join(', ') : '' }} </span>
                </template>
              </artisio-table>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-5 mt-sm-3 mt-lg-0">
          <div class="card">
            <div class="card-header d-flex align-items-center">
              <h5 class="mb-0">{{ $t('Languages') }}</h5>
              <b-button class="ml-auto" variant="link" @click="onAddLanguageClick()">
                <font-awesome-icon :icon="'plus'" style="font-size: .9em"></font-awesome-icon>
                {{ $t('New Language') }}
              </b-button>
            </div>
            <div class="card-body pt-0 pb-0">
              <artisio-table
                  :items="selectedBranch.languages ? selectedBranch.languages : []"
                  :fields="languagesTableFields">
                <template slot="cell(language)" slot-scope="{item: language}">
                  {{ language.name }}
                  <action-buttons :view="false"
                                  @editClick="onEditLanguageClick(language)"
                                  @deleteClick="onRemoveLanguage(language)"/>
                </template>
                <template slot="cell(is_primary)" slot-scope="{item: language}">
                  <span v-if="language.is_primary" class="badge bg-success text-white">{{ $t('Yes') }}</span>
                  <span v-else class="badge bg-danger text-white">{{ $t('No') }}</span>
                </template>
              </artisio-table>
            </div>
          </div>
        </div>
        <language-modal/>
        <clerks-modal/>
      </div>
    </b-tab>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from "vuex";
  import ArtisioTable from "../../../../../core/components/ams-table/ArtisioTable";
  import ClerksModal from "./ClerksModal";
  import LanguageModal from "./LanguageModal";
  import {SOURCE_BRANCH_CLERKS} from "@/modules/constants";
  import ActionButtons from "../../../../../core/components/ams-table/ActionButtons";
  import i18n from "../../../../../shared/i18n";
  import BranchService from "@/modules/setup/branch/BranchService";

  const {mapState, mapActions} = createNamespacedHelpers('setup/branch');

  export default {
    name: "Clerks",
    components: {ActionButtons, ClerksModal, ArtisioTable, LanguageModal},
    data() {
      return {
        tableFields: [
          {key: "name", label: i18n.t('Name')},
          {key: "language", label: i18n.t('Language')},
        ],
        languagesTableFields: [
          {key: "language", label: i18n.t('Language')},
          {key: "is_primary", label: i18n.t('Primary')},
        ],
      };
    },
    computed: {
      ...mapState({
        selectedBranch: state => state.selectedBranch,
      }),
    },
    methods: {
      ...mapActions(['showClerksModal', 'removeClerk', 'showLanguageModal', 'removeLanguage']),
      onAddClerkClick() {
        this.showClerksModal({
          object: {clerks: this.selectedBranch.clerks, branch_uuid: this.selectedBranch.uuid},
          source: SOURCE_BRANCH_CLERKS
        })
      },
      onEditClick(item) {
        this.showClerksModal({
          object: {...item, clerks: this.selectedBranch.clerks},
          source: SOURCE_BRANCH_CLERKS
        });
      },
      onRemoveClick(clerk) {
        this.$confirm(
            this.$i18n.t('Are you sure you want to delete following clerk?'),
            this.$i18n.t('Clerk has been successfully deleted'),
            this.removeClerk,
            clerk
        );
      },
      hasErrors(errors) {
        for (let i in errors) {
          if (errors[i].length > 0) {
            return true;
          }
        }
        return false;
      },
      onEditLanguageClick(item) {
        this.showLanguageModal({
          object: item,
          source: SOURCE_BRANCH_CLERKS
        });
      },
      onAddLanguageClick() {
        this.showLanguageModal({
          object: {branch_uuid: this.selectedBranch.uuid},
          source: SOURCE_BRANCH_CLERKS
        })
      },
      async onRemoveLanguage(language) {
        let success = await this.$confirm(
            this.$i18n.t('Are you sure you want to delete following language?'),
            this.$i18n.t('Language has been successfully deleted'),
            BranchService.removeLanguage,
            language.uuid
        );
        if (success) {
          await this.removeLanguage(language)
        } else if(language.is_primary)
          this.$errorDialog( this.$i18n.t("You should have at least one primary language."))
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>
